import React, { useContext } from 'react';
import ThumbnailUploader from './ThumbnailUploader';
import EditorImageUploader from './EditorImageUploader';
import ImageUploader from './ImageUploader';
import VideoUploader from './VideoUploader';
import AnimationUploader from './AnimationUploader';
import { LocalizationContext } from '../../contexts';

import './index.scss';

export const uploaderTypes = {
    thumbnail: "thumbnail",
    editorImage: "editor_image",
    image: "image",
    seoImage: "seo_image",
    animation: "animation",
    video: "video"
};

const Uploader = ({ type, onChange = () => { }, ...rest }) => {
    const [localization] = useContext(LocalizationContext);
    var uploader = <div></div>;

    switch (type) {
        case uploaderTypes.thumbnail:
            uploader = <ThumbnailUploader onChange={onChange} {...rest} />;
            break;
        case uploaderTypes.editorImage:
            uploader = <EditorImageUploader onChange={onChange} {...rest} localization={localization}/>;
            break;
        case uploaderTypes.image:
        case uploaderTypes.seoImage:
            uploader = <ImageUploader onChange={onChange} {...rest} type={type}/>;
            break;
        case uploaderTypes.video:
          uploader = <VideoUploader onChange={onChange} {...rest}/>;
          break;
        case uploaderTypes.animation:
          uploader = <AnimationUploader onChange={onChange} {...rest}/>;
          break;
        default:
           break;
    }


    return uploader;
};

export default Uploader;